import React from "react";
import { Logo, Menu, NotificationIcon, search } from "../../assets/svgIcons";
import "./style.css";
import { MenuIcon } from "lucide-react";
const Header = ({ setSearchHeaderKey, showAside, setShowAside }) => {
  return (
    <header>
      <div className="header_left flex items-center gap-2 justify-between w-[100%]">
        <span
          className="cursor-pointer"
          style={{ color: "black" }}
          onClick={() => {
            if (setShowAside) {
              setShowAside(!showAside);
            }
          }}
        >
          <MenuIcon className="w-6 h-6" />
        </span>
        {/* <div className="search">
          {search}
          <input
            type="text"
            onChange={(e) => setSearchHeaderKey(e?.target?.value)}
            placeholder="Search for anything"
          />
        </div> */}
        <div className="notification">{NotificationIcon}</div>
      </div>
    </header>
  );
};

export default Header;
